export default __webpack_public_path__ + "static/media/artist-image.42c3e9d2.png";